import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgLocation(props: RootSvgProps) {
  return (
    <RootSvg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.0055 10C10.5227 10 10.9635 9.81589 11.3281 9.44766C11.6927 9.07943 11.875 8.63672 11.875 8.11953C11.875 7.60234 11.6909 7.16146 11.3227 6.79687C10.9544 6.43229 10.5117 6.25 9.99453 6.25C9.47734 6.25 9.03646 6.43411 8.67187 6.80234C8.30729 7.17057 8.125 7.61328 8.125 8.13047C8.125 8.64766 8.30911 9.08854 8.67734 9.45312C9.04557 9.81771 9.48828 10 10.0055 10ZM10 17.526C12.066 15.6684 13.6241 13.9583 14.6745 12.3958C15.7248 10.8333 16.25 9.43576 16.25 8.20312C16.25 6.38021 15.6554 4.86979 14.4661 3.67187C13.2769 2.47396 11.7882 1.875 10 1.875C8.21181 1.875 6.72309 2.47396 5.53385 3.67187C4.34462 4.86979 3.75 6.38021 3.75 8.20312C3.75 9.43576 4.27517 10.8333 5.32552 12.3958C6.37587 13.9583 7.93403 15.6684 10 17.526ZM10 20C7.27483 17.7238 5.23932 15.6096 3.89349 13.6576C2.54783 11.7053 1.875 9.88715 1.875 8.20312C1.875 5.87674 2.64757 3.92795 4.19271 2.35677C5.73785 0.78559 7.66927 0 9.98698 0C12.3047 0 14.2405 0.78559 15.7943 2.35677C17.3481 3.92795 18.125 5.87674 18.125 8.20312C18.125 9.88715 17.4566 11.7014 16.1198 13.6458C14.783 15.5903 12.7431 17.7083 10 20Z"
        fill="#5F3BE5"
      />
    </RootSvg>
  );
}
